<form
  *ngIf="equipment && attachmentsFormArray"
  (submit)="$event.preventDefault()"
  (keydown.enter)="$event.preventDefault()"
  class="field-dialog__content__scroll p-24 overflow-x-hidden"
  [ngClass]="{ 'with-disclaimer': isViewMode }"
  fusePerfectScrollbar
  [fusePerfectScrollbarOptions]="{ suppressScrollX: true }"
  autocomplete="off"
  name="form"
  ngNoForm
>
  <div *ngIf="!attachmentsFormArray.controls.length" fxLayout="column" fxLayoutAlign="center center" class="p-24">
    <p>
      <mat-icon class="font-size-32">insert_photo</mat-icon>
    </p>
    <span class="h3">
      {{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.NO_ATTACHMENTS' | translate }}
    </span>
  </div>

  <label
    *ngIf="!isViewMode"
    for="add-attachment-input"
    class="new-attachment-button"
    [ngClass]="{
      'new-attachment-button--disabled': isSaving || images.isUploading,
      'error-attachment-button': images.hasErrors.size || images.hasErrors.type || images.hasErrors.max
    }"
    fxLayout="column"
    fxLayoutAlign="center center"
    matRipple
  >
    <mat-icon *ngIf="!images.isUploading" class="upload-icon">cloud_upload</mat-icon>
    <mat-spinner *ngIf="images.isUploading" color="primary" [diameter]="28"></mat-spinner>

    <p *ngIf="images.isUploading" class="h4 new-attachment-button__text">
      {{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.UPLOADING' | translate }}
    </p>

    <p
      *ngIf="!images.hasErrors.size && !images.hasErrors.type && !images.hasErrors.max && !images.isUploading"
      class="h4 new-attachment-button__text"
    >
      {{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.ADD' | translate }}
    </p>
    <p *ngIf="images.hasErrors.size && !images.isUploading" class="h4 new-attachment-button__text">
      {{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.ERRORS.IMAGE_SIZE' | translate }}
    </p>
    <p *ngIf="images.hasErrors.type && !images.isUploading" class="h4 new-attachment-button__text">
      {{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.ERRORS.IMAGE_TYPE' | translate }}
    </p>
    <p *ngIf="images.hasErrors.max && !images.isUploading" class="h4 new-attachment-button__text">
      {{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.ERRORS.IMAGE_MAX' | translate }}
    </p>

    <small *ngIf="!images.isUploading" class="new-attachment-button__observation">
      {{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.MAX_SIZE' | translate }}
    </small>
  </label>
  <input
    id="add-attachment-input"
    [disabled]="isSaving || images.isUploading"
    type="file"
    accept="image/*"
    class="file-input"
    multiple
    (change)="addNewAttachments($event)"
  />

  <div *ngIf="attachmentsFormArray.controls.length">
    <div class="attachment w-100-p" *ngFor="let attachment of attachmentsFormArray.controls; index as index">
      <div fxLayout="row" class="attachment__outer-container">
        <div class="attachment__preview" [style.backgroundImage]="'url(' + attachment.value.path + ')'"></div>

        <mat-card
          *ngIf="attachment.value.isDeleting"
          [@slideInRight]
          fxLayout="row"
          fxLayoutAlign="center center"
          class="attachment__confirm-delete"
        >
          <span>{{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.CONFIRM_DELETE' | translate }}</span>
          <button
            class="field-background ml-6"
            mat-raised-button
            [disabled]="isSaving || images.isUploading"
            (click)="deleteAttachment(attachment, index)"
          >
            {{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.YES' | translate }}
          </button>
          <button
            class="ml-8"
            mat-raised-button
            [disabled]="isSaving || images.isUploading"
            (click)="attachment.get('isDeleting').setValue(false)"
          >
            {{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.NO' | translate }}
          </button>
        </mat-card>

        <div fxLayout="column" fxFlex="53">
          <div fxLayout="row" fxLayoutAlign="start start">
            <span *ngIf="!attachment.value.isChangingTitle" class="attachment__title">
              {{ attachment.value.title || 'EQUIPMENTS.DIALOG.ATTACHMENTS.NO_TITLE' | translate }}
            </span>
            <input
              *ngIf="attachment.value.isChangingTitle"
              id="attachment-{{ index }}-title"
              [formControl]="attachment.get('newTitle')"
              class="attachment__title_input"
              maxlength="100"
              autocomplete="off"
            />
            <button
              *ngIf="!isViewMode && !attachment.value.isChangingTitle"
              class="attachment__title_button ml-6"
              [disabled]="isSaving"
              [ngClass]="{ 'attachment__title_button--disabled': isSaving }"
              (click)="enableChangeAttachmentTitle(attachment, index)"
              matTooltip="{{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.CHANGE_TITLE' | translate }}"
            >
              <mat-icon class="font-size-16"> edit </mat-icon>
            </button>

            <div *ngIf="isSaving && updatingAttachmentId === attachment.value.id" class="ml-6">
              <mat-spinner color="primary" [diameter]="20"></mat-spinner>
            </div>

            <button
              *ngIf="attachment.value.isChangingTitle"
              [disabled]="
                attachment.value.title === attachment.value.newTitle || !attachment.value.newTitle || isSaving
              "
              [ngClass]="{
                'attachment__title_button--disabled':
                  attachment.value.title === attachment.value.newTitle || !attachment.value.newTitle || isSaving
              }"
              class="attachment__title_button ml-6"
              (click)="updateAttachmentTitle(attachment)"
              matTooltip="{{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.CONFIRM_CHANGE_TITLE' | translate }}"
            >
              <mat-icon class="font-size-20"> check_circle </mat-icon>
            </button>
            <button
              *ngIf="attachment.value.isChangingTitle"
              class="attachment__title_button ml-2"
              (click)="cancelChangeAttachmentTitle(attachment)"
              matTooltip="{{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.CANCEL_CHANGE_TITLE' | translate }}"
            >
              <mat-icon class="font-size-20"> cancel </mat-icon>
            </button>
          </div>
          <span class="attachment__time">
            {{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.ADDED_IN' | translate }}
            {{ attachment.value.createdAt | date: 'dd/MM/yyyy HH:mm' }}
          </span>
          <a class="attachment__link" [href]="attachment.value.path" target="_blank">
            {{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.VIEW' | translate }}
          </a>
        </div>
        <div *ngIf="!isViewMode" fxLayout="column" fxLayoutAlign="start end" fxFlex="7">
          <mat-icon
            class="attachment__delete"
            (click)="attachment.get('isDeleting').setValue(true)"
            matTooltip="{{ 'EQUIPMENTS.DIALOG.ATTACHMENTS.REMOVE' | translate }}"
          >
            delete
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
</form>
